export const GlobalDebug = (function () {
    const originalConsole = { ...console };
    
    return function (debugOn, suppressAll = false) {
      if (!debugOn) {
        console.log = () => {};
        if (suppressAll) {
          console.info = () => {};
          console.warn = () => {};
          console.error = () => {};
        } else {
          console.info = originalConsole.info;
          console.warn = originalConsole.warn;
          console.error = originalConsole.error;
        }
      } else {
        Object.assign(console, originalConsole);
      }
    };
  })();
  